import CURRENT_PREPAYMENT from './currentPrepayment.gql';

export {
  CURRENT_PREPAYMENT,
};
